// Automatisch gebaut: node CODEX/PROFIL_PIPELINE/theme/build.mjs
(() => {
"use strict";
const STANDARD_KONFIGURATION = {"gehrungsPreisCent":100,"version":"TN-PROFIL-08-v1"};
const STUFEN_CENT = Object.freeze([10,20,25,50,100]);
function fehler(code, message) {
  const error = new Error(message); error.code = code; throw error;
}
function ganzzahl(value, min, max, name) {
  if (!Number.isSafeInteger(value) || value < min || value > max)
    fehler('UNGUELTIGE_ZAHL', `${name} muss eine ganze Zahl von ${min} bis ${max} sein.`);
  return value;
}
function text(value, name) {
  if (typeof value !== 'string' || !value.trim() || value.length > 256)
    fehler('EIGENSCHAFT_UNGUELTIG', `${name} fehlt oder ist ungültig.`);
  return value;
}
function konfig(input = {}) {
  const c = { ...STANDARD_KONFIGURATION, ...input };
  ganzzahl(c.gehrungsPreisCent, 0, Number.MAX_SAFE_INTEGER, 'Gehrungspreis in Cent');
  if (Object.hasOwn(c, 'maxSchnitte')) fehler('ALTE_SCHNITTZAHL', 'Schnittzahlen werden nicht mehr unterstützt.');
  text(c.version, 'Version');
  return c;
}
function sichereZahl(value) {
  if (value > BigInt(Number.MAX_SAFE_INTEGER)) fehler('PREIS_UEBERLAUF', 'Preis überschreitet den sicheren Ganzzahlbereich.');
  return Number(value);
}

function berechnePreis({ eurJeMBruttoCent, laengeMm, gehrung = 0, stufeCent = 10, konfiguration = {}, schnitte }) {
  if (schnitte !== undefined) fehler('ALTE_SCHNITTZAHL', 'Schnittzahlen werden nicht mehr unterstützt.');
  const c = konfig(konfiguration);
  ganzzahl(eurJeMBruttoCent, 0, Number.MAX_SAFE_INTEGER, 'Meterpreis in Cent');
  ganzzahl(laengeMm, 100, 6000, 'Länge in mm');
  ganzzahl(gehrung, 0, 1, 'Gehrung');
  if (!STUFEN_CENT.includes(stufeCent)) fehler('STUFENGROESSE','Unzulässige Stufengröße.');
  const exakt = (BigInt(laengeMm) * BigInt(eurJeMBruttoCent) + 500n) / 1000n + BigInt(gehrung) * BigInt(c.gehrungsPreisCent);
  const stufe = (exakt + BigInt(stufeCent)-1n) / BigInt(stufeCent);
  const preis = stufe * BigInt(stufeCent);
  return { exaktCent: sichereZahl(exakt), stufenNummer: sichereZahl(stufe), stufeCent,
    stufePreisCent: sichereZahl(preis), aufschlagCent: sichereZahl(preis-exakt) };
}

// Kleinste benutzbare und größte Stufe über alle Oberflächen (für Metafeld-Prüfung und Seite).
function stufenSpanne({ eurJeMCent, gehrung = 0, stufeCent, konfiguration = {} }) {
  const raten = Object.values(eurJeMCent);
  if (!raten.length) fehler('OBERFLAECHE_FEHLT', 'Belegte Oberflächen fehlen.');
  let minStufe = Infinity, maxStufe = 0;
  for (const rate of raten) {
    minStufe = Math.min(minStufe, berechnePreis({ eurJeMBruttoCent: rate, laengeMm: 100, gehrung: 0, stufeCent, konfiguration }).stufenNummer);
    maxStufe = Math.max(maxStufe, berechnePreis({ eurJeMBruttoCent: rate, laengeMm: 6000, gehrung, stufeCent, konfiguration }).stufenNummer);
  }
  return { minStufe, maxStufe };
}

function referenz(values) {
  const serialized = JSON.stringify(values);
  let first = 0x811c9dc5, second = 0x9e3779b9;
  for (let i = 0; i < serialized.length; i++) {
    first = Math.imul(first ^ serialized.charCodeAt(i), 0x01000193) >>> 0;
    second = Math.imul(second ^ serialized.charCodeAt(serialized.length - i - 1), 0x85ebca6b) >>> 0;
  }
  return `TN-P08-${first.toString(16).padStart(8, '0')}${second.toString(16).padStart(8, '0')}`;
}

function zeilenEigenschaften({code,oberflaeche,laengeMm,gehrung=0,stufePreisCent,version=STANDARD_KONFIGURATION.version}) {
 text(code,'Produktcode');text(oberflaeche,'Oberfläche');text(version,'Version');
 ganzzahl(laengeMm,100,6000,'Länge in mm');ganzzahl(gehrung,0,1,'Gehrung');ganzzahl(stufePreisCent,0,Number.MAX_SAFE_INTEGER,'Stufenpreis in Cent');
 return {'Länge (mm)':String(laengeMm),'Oberfläche':oberflaeche,'Gehrung an den Stegen':gehrung?'ja (alle Enden)':'nein',
 _tn_code:code,_tn_oberflaeche:oberflaeche,_tn_laenge_mm:String(laengeMm),_tn_gehrung:String(gehrung),
 _tn_stufe_cent:String(stufePreisCent),_tn_version:version,
 _tn_pruefsumme:referenz([code,oberflaeche,laengeMm,gehrung,stufePreisCent,version])};
}

const namen = { blank: 'Blank', elox: 'Eloxiert', 'schwarz-elox': 'Schwarz eloxiert' };
const euro = cent => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
const datenFehler = 'Die Produktdaten sind unvollständig oder widersprüchlich. Eine Bestellung ist derzeit nicht möglich.';

function pruefeMetafelder(d, v) {
  if (!d || !v || typeof v !== 'object' || Array.isArray(v) ||
      typeof d.code !== 'string' || !/^TN-[A-Z0-9-]+$/.test(d.code) ||
      typeof d.version !== 'string' || !d.version || d.version.length > 256 ||
      !STUFEN_CENT.includes(d.stufeCent) || d.minMm !== 100 || d.maxMm !== 6000 ||
      typeof d.gehrungErlaubt !== 'boolean' || !Number.isSafeInteger(d.gehrungCent) || d.gehrungCent < 0 ||
      !d.eurJeMCent || typeof d.eurJeMCent !== 'object' || Array.isArray(d.eurJeMCent)) throw new Error(datenFehler);
  const surfaces = Object.keys(d.eurJeMCent), ids = new Set();
  if (!surfaces.length) throw new Error(datenFehler);
  for (const s of surfaces) {
    if (!Object.hasOwn(namen, s) || !Number.isSafeInteger(d.eurJeMCent[s]) || d.eurJeMCent[s] <= 0) throw new Error(datenFehler);
  }
  // Eine einzige Reihe Stufe -> Varianten-ID, lückenlos von der kleinsten bis zur größten Stufe aller Oberflächen.
  const { minStufe, maxStufe } = stufenSpanne({ eurJeMCent: d.eurJeMCent, gehrung: Number(d.gehrungErlaubt), stufeCent: d.stufeCent,
    konfiguration: { gehrungsPreisCent: d.gehrungCent, version: d.version } });
  if (Object.keys(v).length !== maxStufe - minStufe + 1) throw new Error(datenFehler);
  for (let i = minStufe; i <= maxStufe; i++) {
    const id = v[i];
    if (!Number.isSafeInteger(id) || id < 1 || ids.has(id)) throw new Error(datenFehler);
    ids.add(id);
  }
  if (ids.size > 2048) throw new Error(datenFehler);
  return surfaces;
}

function mountProfil(host, { fetchImpl = globalThis.fetch, root = '/' } = {}) {
  const q = name => host.querySelector(`[data-profil-${name}]`);
  const mainImage = q('hauptbild');
  const thumbnails = [...(host.querySelectorAll?.('[data-profil-vorschaubild]') ?? [])];
  function showImage(link) {
    if (!mainImage || !link) return;
    // Ohne JavaScript stehen die Originalbilder als noscript-Links bereit.
    mainImage.removeAttribute('srcset');
    mainImage.setAttribute('src', link.getAttribute('data-bild-src'));
    mainImage.setAttribute('alt', link.getAttribute('data-bild-alt') ?? '');
    mainImage.setAttribute('width', link.getAttribute('data-bild-breite'));
    mainImage.setAttribute('height', link.getAttribute('data-bild-hoehe'));
    for (const thumbnail of thumbnails) thumbnail.setAttribute('aria-current', String(thumbnail === link));
  }
  for (const link of thumbnails) link.addEventListener('click', event => {
    if (!mainImage || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault(); showImage(link);
  });
  const form = q('form'), length = q('laenge'), surface = q('oberflaeche'), cut = q('gehrung'), quantity = q('menge');
  const button = q('submit'), status = q('status'), lengthError = q('laenge-fehler'), quantityError = q('menge-fehler');
  function showSurface() {
    const suffix = { blank: ', blank', elox: ', eloxiert', 'schwarz-elox': ', schwarz eloxiert' }[surface.value];
    if (suffix) showImage(thumbnails.find(link => (link.getAttribute('data-bild-alt') ?? '').endsWith(suffix)));
  }
  function showCut() {
    const image = cut.checked ? thumbnails.find(link => (link.getAttribute('data-bild-alt') ?? '').includes('Gehrungsschnitt')) : null;
    if (image) showImage(image); else showSurface();
  }
  cut.addEventListener('change', showCut);
  cut.addEventListener('input', showCut);
  surface.addEventListener('change', showSurface);
  surface.addEventListener('input', showSurface);
  let lengthTouched = false;
  let data, variants, busy = false, uncertain = false, fatal = '';
  button.disabled = true;
  try {
    data = JSON.parse(q('daten').textContent); variants = JSON.parse(q('varianten').textContent);
    const surfaces = pruefeMetafelder(data, variants);
    surface.replaceChildren(...surfaces.map(s => {
      const option = host.ownerDocument.createElement('option'); option.value = s; option.textContent = namen[s]; return option;
    }));
    q('gehrung-feld').hidden = !data.gehrungErlaubt;
    cut.checked = false; cut.disabled = !data.gehrungErlaubt;
    q('gehrung-preis').textContent = '+ ' + euro(data.gehrungCent) + ' je Stück';
  } catch { fatal = datenFehler; status.textContent = fatal; }
  // Nur lokale Shop-Routen; keine fremden Hosts oder unbemerkten Nachladepfade.
  if (typeof root !== 'string' || !/^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(root)) { fatal = datenFehler; status.textContent = fatal; }

  function read() {
    lengthError.textContent = ''; quantityError.textContent = '';
    length.setAttribute('aria-invalid', 'false'); quantity.setAttribute('aria-invalid', 'false');
    const validLength = /^\d{1,4}$/.test(length.value) && Number(length.value) >= 100 && Number(length.value) <= 6000;
    const validQuantity = /^[1-9]\d{0,15}$/.test(quantity.value) && Number.isSafeInteger(Number(quantity.value));
    if (!validLength && lengthTouched) {
      lengthError.textContent = 'Bitte eine ganze Länge von 100 bis 6.000 mm eingeben.';
      length.setAttribute('aria-invalid', 'true');
    }
    if (!validQuantity) {
      quantityError.textContent = 'Bitte eine ganze Stückzahl ab 1 eingeben.';
      quantity.setAttribute('aria-invalid', 'true');
    }
    if (fatal || !validLength || !validQuantity) return null;
    if (!Object.hasOwn(data.eurJeMCent, surface.value) || (cut.checked && !data.gehrungErlaubt)) throw new Error(datenFehler);
    const price = berechnePreis({ eurJeMBruttoCent: data.eurJeMCent[surface.value], laengeMm: Number(length.value),
      gehrung: Number(cut.checked), stufeCent: data.stufeCent, konfiguration: { gehrungsPreisCent: data.gehrungCent, version: data.version } });
    const id = variants[price.stufenNummer], total = price.stufePreisCent * Number(quantity.value);
    if (!Number.isSafeInteger(id) || id < 1 || price.stufePreisCent < price.exaktCent || !Number.isSafeInteger(total)) throw new Error(datenFehler);
    return { id, quantity: Number(quantity.value), price, total, properties: zeilenEigenschaften({ code: data.code,
      oberflaeche: surface.value, laengeMm: Number(length.value), gehrung: Number(cut.checked), stufePreisCent: price.stufePreisCent, version: data.version }) };
  }
  function update() {
    let quote = null;
    try { quote = read(); } catch (e) { status.textContent = e.message; }
    q('einzelpreis').textContent = quote ? euro(quote.price.stufePreisCent) : '–';
    q('gesamtpreis').textContent = quote ? euro(quote.total) : '–';
    const hint = q('preishinweis'), note = 'inkl. MwSt., zzgl. Versand';
    if (hint) hint.textContent = quote && quote.quantity > 1 ? `${quote.quantity} × ${euro(quote.price.stufePreisCent)} · ${note}` : note;
    button.disabled = busy || uncertain || !quote;
    return quote;
  }
  for (const input of [length, surface, cut, quantity]) {
    input.addEventListener('input', update); input.addEventListener('change', update);
  }
  for (const type of ['input', 'change', 'blur']) length.addEventListener(type, () => { lengthTouched = true; update(); });
  async function submit(event) {
    event.preventDefault();
    if (busy || uncertain) return;
    lengthTouched = true;
    const quote = update();
    if (!quote) { (length.getAttribute('aria-invalid') === 'true' ? length : quantity).focus(); return; }
    busy = true; button.disabled = true; button.textContent = 'Wird hinzugefügt …'; form.setAttribute('aria-busy', 'true');
    status.textContent = '';
    // Eingaben während des Requests sperren: Erfolg gehört genau zur gesendeten Auswahl.
    const controls = [length, surface, cut, quantity]; controls.forEach(x => { x.disabled = true; });
    try {
      const response = await fetchImpl(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: quote.id, quantity: quote.quantity, properties: quote.properties }] }) });
      if (!response.ok) {
        status.textContent = 'Der Artikel konnte nicht hinzugefügt werden. Bitte prüfe die Verfügbarkeit und versuche es erneut.';
      } else {
        status.textContent = 'Dein Profil wurde zum Warenkorb hinzugefügt.';
        q('cart').hidden = false; q('cart').setAttribute('href', root + 'cart'); q('cart').focus();
      }
    } catch {
      uncertain = true;
      status.textContent = 'Die Antwort des Shops fehlt. Bitte prüfe zuerst deinen Warenkorb und lade die Seite neu, bevor du erneut bestellst.';
      q('cart').hidden = false; q('cart').setAttribute('href', root + 'cart');
    } finally {
      busy = false; controls.forEach(x => { x.disabled = false; }); cut.disabled = !data?.gehrungErlaubt;
      form.setAttribute('aria-busy', 'false'); button.textContent = 'In den Warenkorb'; update();
    }
  }
  form.addEventListener('submit', submit); update();
  return { update, submit };
}

const mounted = globalThis[Symbol.for('tn.profil.mounted')] ??= new WeakSet();
function mountAll(scope = document) {
  const hosts = [...(scope.matches?.('[data-profil-konfigurator]') ? [scope] : []), ...scope.querySelectorAll('[data-profil-konfigurator]')];
  for (const host of hosts) if (!mounted.has(host)) { mounted.add(host); mountProfil(host, { root: globalThis.Shopify?.routes?.root ?? '/' }); }
}
mountAll();
document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
